/**
 * Minimal error telemetry for STRTGY Content Engine.
 * Dev: logs to console. Production: stub for future POST /api/telemetry/error.
 * No PII or tokens; only path, method, status, request_id, error_code.
 */

export interface ApiErrorReport {
  path: string
  method: string
  status: number
  request_id?: string
  error_code?: string
}

export interface ReactErrorReport {
  message: string
  componentStack?: string
}

const isDev = import.meta.env.DEV

export const telemetry = {
  reportApiError(payload: ApiErrorReport): void {
    if (isDev) {
      console.warn('[telemetry] API error:', payload)
    }
    // Production: extend later, e.g. POST to /api/telemetry/error
    // fetch(..., { method: 'POST', body: JSON.stringify(payload) }).catch(() => {})
  },

  reportReactError(payload: ReactErrorReport): void {
    if (isDev) {
      console.warn('[telemetry] React error:', payload)
    }
    // Production: same endpoint or separate; ensure no PII in message/componentStack
  },
}
